import React from 'react';
import * as TablerIcons from '@tabler/icons-react';

// Default size and stroke width for all icons
const defaultSize = '1em';
const defaultStrokeWidth = 2;
const defaultColor = "currentColor";

const getIcon = (IconComponent) => {
  return (
    <IconComponent
      className="anticon"
      size={defaultSize}
      strokeWidth={defaultStrokeWidth}
      defaultColor={defaultColor}
    />
  );
};

// Create the icon map
const IconMap = {};
Object.keys(TablerIcons).forEach((iconName) => {
  IconMap[iconName] = getIcon(TablerIcons[iconName]);
});

export default IconMap;